<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre2"><span id="Page_41" title="41"></span><h2 id="pgepubid00012">CHAPTER VI</h2>
</div>
<h3 class="calibre1 sigil_not_in_toc" id="pgepubid00013">MR. MAITLAND GOES SHOPPING</h3>
<p class="pindent"><span>E</span>LDOR STREET, Tottenham, was one of thousands of
drab and ugly thoroughfares that make up the central
suburbs of London. Imagine two rows of houses set on either
side of a straight street, lighted at economic intervals by yellow
lamps. Each house has a protuberance, called a bay window;
each house is separated from the road by iron railings pierced
by an iron gate. There is a tiny forecourt in which the hardiest
of shrubs battle desperately for existence; there is one recessed
door, and on the floor above two windows exactly alike.</p>
<p class="pindent">Elk found himself in Eldor Street at nine o’clock that night.
The rain was pelting down, and the street in consequence was
a desert. Most of the houses were dark, for Eldor Street
lives in its kitchens, which are back of the houses. In the
front window of No. 47 one crack of light showed past the edge
of the lowered blind, and, creeping up to the window, he heard,
at long intervals, the mumble of conversation.</p>
<p class="pindent">It was difficult to believe that he was standing at the door
of Ezra Maitland’s home. That morning the newspapers had
given prominence to the newest speculation of Maitlands Consolidated—a
deal involving something over a million. And
the master-mind of the concern lived in this squalor!</p>
<p class="pindent">Whilst he was standing there, the light was extinguished and
there came to him the sound of feet in the uncarpeted passage.
He had time to reach the obscurity of the other side of the
street, when the door opened and two people came out:
Maitland and the old woman he had seen. By the light of a
street-lamp he saw that Maitland wore an overcoat buttoned
to his chin. The old woman had on a long ulster, and in her
hand she carried a string bag. They were going marketing!
It was Saturday night, and the main street, through which Elk
had passed, had been thronged with late shoppers—Tottenham
leaves its buying to the last, when food can be had at bargain
prices.</p>
<p class="pindent">Waiting until they were out of sight, Elk walked down the
street to the end and turned to the left. He followed a wall
covered with posters until he reached a narrow opening. This
was the passage between the gardens—a dark, unlighted alleyway,
three feet wide and running between tar-coated wooden
fences. He counted the gates on his left with the help of his
flash-lamp, and after a while stopped before one of them and
pushed gently. The gate was locked—it was not bolted.
There was a keyhole that had the appearance of use. Elk
grunted his satisfaction, and, taking from his pocket a wallet,
extracted a small wooden handle, into which he fitted a steel
hook, chosen with care from a dozen others. This he inserted
into the lock and turned. Evidently the lock was more complicated
than he had expected. He tried another hook of a
different shape, and yet another. At the fourth trial the lock
turned and he pushed open the door gently.</p>
<p class="pindent">The back of the house was in darkness, the yard singularly
free from the obstructions which he had anticipated. He
crossed to the door leading into the house. To his surprise it
was unfastened, and he replaced his tools in his pocket. He
found himself in a small scullery. Passing through a door into
the bare passage, he came to the room in which he had seen
the light. It was meanly and shabbily furnished. The arm-chair
near the fireplace had broken springs, there was an untidy
bed in one corner, and in the centre of the room a table covered
with a patched cloth. On this were two or three books and a
few sheets of paper covered with the awkward writing of a
child. Elk read curiously.</p>
<p class="pindent">“Look at the dog,” it ran. “The man goes up to the
dog and the dog barks at the man.”</p>
<p class="pindent">There was more in similar strain. The books were children’s
primers of an elementary kind. Looking round, he
saw a cheap gramophone and on the sideboard half a dozen
scratched and chipped records.</p>
<p class="pindent">The child must be in the house. Turning on the gas, he
lit it, after slipping a bolt in the front door to guard against
surprise. In the more brilliant light, the poverty of the
room staggered him. The carpet was worn and full of holes;
there was not one article of furniture which had not been
repaired at some time or other. On the dingy sideboard
was a child’s abacus—a frame holding wires on which beads
were strung, and by means of which the young are taught
to count. A paper on the mantelpiece attracted him. It
was a copy of the million pound contract which Maitland
had signed that morning. His neat signature, with the
characteristic flourish beneath, was at the foot.</p>
<p class="pindent">Elk replaced the paper and began a search of the apartment.
In a cupboard by the side of the fireplace he found
an iron money-box, which he judged was half-full of coins.
In addition, there were nearly a hundred letters addressed
to E. Maitland, 47 Eldor Street, Tottenham. Elk, glancing
through them, recognized their unimportance. Every one
was either a tradesman’s circular or those political pamphlets
with which candidates flood their constituencies. And they
were all unopened. Mr. Maitland evidently knew what they
were also, and had not troubled to examine their contents.
Probably the hoarding instincts of age had made him keep
them. There was nothing else in the room of interest. He
was certain that this was where the old man slept—where
was the child?</p>
<p class="pindent">Turning out the light, he went upstairs. One door was
locked, and here his instruments were of no avail, for the
lock was a patent one and was recently fixed. Possibly the
child was there, he thought. The second room, obviously
the old woman’s, was as meanly furnished as the parlour.</p>
<p class="pindent">Coming back to the landing, his foot was poised to reach
the first stair when he heard a faint “click.” It came from
below, and was the sound of a door closing. Elk waited,
listening. The sound was not repeated, and he descended
softly. At first he thought that the old man had returned,
and was trying his key on the bolted door, but when he crept
to the door to listen, he heard no sound, and slipping back
the bolt, he went to the second of the rooms on the ground
floor and put his light on the door.</p>
<p class="pindent">Elk was a man of keen observation; very little escaped
him, and he was perfectly certain that this door had been
ajar when he had passed it on entering the house. It was
closed now and fastened from the inside, the key being in
the lock.</p>
<p class="pindent">Was it the child, frightened by his presence? Elk was
wise enough a man not to investigate too closely. He made
the best of his way back to the garden passage and into the
street. Here he waited, taking up a position which enabled
him to see the length of Eldor Street and the passage opening
in the wall. Presently he saw Maitland returning. The old
man was carrying the string bag, which now bulged. Elk
saw the green of a cabbage as they passed under the light.
He watched them until the darkness swallowed them up,
and heard the sound of their closing door. Five minutes
later, a dark figure came from the passage behind the houses.
It was a man, and Elk, alert and watchful, swung off in
pursuit.</p>
<p class="pindent">The stranger plunged into a labyrinth of little streets with
the detective at his heels. He was walking quickly, but not
too quickly for Elk, who was something of a pedestrian.
Into the glare of the main road the stranger turned, Elk a
dozen paces behind him. He could not see his face, nor did
he until his quarry stopped by the side of a waiting car,
opened the door and jumped in. Then it was that Elk came
abreast and raised his hand in cheery salutation.</p>
<p class="pindent">For a second the man in the closed limousine was taken
aback, and then he opened the door.</p>
<p class="pindent">“Come right in out of the rain, Elk,” he said, and Elk
obeyed.</p>
<p class="pindent">“Been doing your Sunday shopping?” he asked innocently.</p>
<p class="pindent">The man’s hawk-like face relaxed into a smile.</p>
<p class="pindent">“I never eat on Sundays,” he said.</p>
<p class="pindent">It was Joshua Broad, that rich American who peddled
key-rings in Whitehall, lived in the most expensive flats in
London, and found time to be intensely interested in Ezra
Maitland.</p>
<p class="pindent">He turned abruptly as Elk seated himself.</p>
<p class="pindent">“Say, Elk, did you see the child?”</p>
<p class="pindent">Elk shook his head.</p>
<p class="pindent">“No,” he said, and heard the chuckle of his companion
as the car moved toward the civilized west.</p>
<p class="pindent">“Yes, I saw that baby,” said Mr. Broad, puffing gently
at the cigar he had lit; “and, believe me, Elk, I’ve stopped
loving children. Yes, sir. The education of the young means
less than nothing to me for evermore.”</p>
<p class="pindent">“Where was she?”</p>
<p class="pindent">“It’s a ‘he,’ ” replied Broad calmly, “and I hope I’ll
be excused answering your question. I had been in the house
an hour when you arrived—I was in the back room, which
is empty, by the way. You scared me. I heard you come
in and thought it was old St. Nicholas of the Whiskers.
Especially when I saw the light go on. I’d had it on when
you opened the scullery door—I left that unfastened, by the
way. Didn’t want to stop my bolt hole. Well, what do
you think?”</p>
<p class="pindent">“About Maitland?”</p>
<p class="pindent">“Eccentric, eh? You don’t know how eccentric!”</p>
<p class="pindent">As the car stopped before the door of Caverley House,
Elk broke a long silence.</p>
<p class="pindent">“What are you, Mr. Broad?”</p>
<p class="pindent">“I’ll give you ten guesses,” said the other cheerfully as
they got out.</p>
<p class="pindent">“Secret Service man,” suggested Elk promptly.</p>
<p class="pindent">“Wrong—you mean U.S.? No, you’re wrong. I’m a
private detective who makes a hobby of studying the criminal
classes—will you come up and have a drink?”</p>
<p class="pindent">“I will come up, but I won’t drink,” said Elk virtuously,
“not if you offer gin and orange. That visit to the United
States has spoilt my digestion.”</p>
<p class="pindent">Broad was fitting a key in the lock of his flat, when a
strange cold sensation ran down the spine of the detective,
and he laid his hand on the American’s arm.</p>
<p class="pindent">“Don’t open that door,” he said huskily.</p>
<p class="pindent">Broad looked round in surprise. The yard man’s face was
tense and drawn.</p>
<p class="pindent">“Why not?”</p>
<p class="pindent">“I don’t know . . . just a feeling, that’s all. I’m Scot
by birth . . . we’ve got a word ‘fey,’ which means something
supernatural. And it says inside me, ‘don’t open that
door.’ ”</p>
<p class="pindent">Broad put down his hand.</p>
<p class="pindent">“Are you being fey or funny?” he asked.</p>
<p class="pindent">“If I look funny,” said Elk, “I’m entitled to sue my face
for libel. There’s something at the other side of that door
that isn’t good. I’ll take an oath on it! Give me that!”</p>
<p class="pindent">He took the key from the unwilling hand of Joshua Broad,
thrust it in the lock and turned it. Then, with a quick push,
he threw open the door, pushing Broad to the cover of the
wall.</p>
<p class="pindent">Nothing happened for a second, and then:</p>
<p class="pindent">“Run!” cried Elk, and leapt for the stairs.</p>
<p class="pindent">The American saw the first large billow of greenish-yellowy
mist that rolled from the open door, and followed.</p>
<p class="pindent">The hall-porter was closing his office for the night when
Elk appeared, hatless and breathless.</p>
<p class="pindent">“Can you ’phone the flats?—good! Get on at once to
every one on and below the third floor, and tell them on no
account to open their doors. Tell ’em to close all cracks
with paper, to stop up their letter-boxes, and open all windows.
Don’t argue—do it! The building is full of poison gas!”</p>
<p class="pindent">He himself ’phoned the fire station, and in a few seconds
the jangle of bells sounded in the street outside, and men in
gas-masks were clattering up the stairs.</p>
<p class="pindent">Fortunately, every tenant except Broad and his neighbour
was out of town for the week-end.</p>
<p class="pindent">“And Miss Bassano doesn’t come in till early morning,”
said the porter.</p>
<p class="pindent">It was daylight before the building was cleared by the
aid of high-pressure air-hoses and chemical precipitants.
Except that his silver was tarnished black, and every window
glass and mirror covered with a yellow deposit, little harm had
been done. A musty odour pervaded the flat in spite of the
open windows, but later came the morning breeze to dispel
the last trace of this malodorous souvenir of the attempt.</p>
<p class="pindent">Together the two men made a search of the rooms to discover
the manner in which the gas was introduced.</p>
<p class="pindent">“Through that open fireplace,” Elk pointed. “The gas
is heavier than air, and could be poured down the chimney
as easily as pouring water.”</p>
<p class="pindent">A search of the flat roof satisfied him that his theory was
right. They found ten large glass cylinders and a long rope,
to which a wicker cradle was attached. Moreover, one of the
chimney-pots (easily reached from the roof) was scratched and
discoloured.</p>
<p class="pindent">“The operator came into the building when the porter
was busy—working the lift probably. He made his way to
the roof, carrying the rope and the basket. Somebody in
the street fixed the cylinders in the basket, which the man
hauled to the roof one by one. It was dead easy, but ingenious.
They must have made a pretty careful survey beforehand,
or they wouldn’t have known which chimney led to
your room.”</p>
<p class="pindent">They returned to the flat, and for once Joshua Broad was
serious.</p>
<p class="pindent">“Fortunately, my servant is on a holiday,” he said, “or
he would have been in heaven!”</p>
<p class="pindent">“I hope so,” responded Elk piously.</p>
<p class="pindent">The sun was tipping the roofs of the houses when he finally
left, a sleepy and a baffled man. He heard the sound of
boisterous voices before he reached the vestibule. A big car
stood at the entrance of the flats, and, seated at the wheel,
was a young man in evening dress. By him sat Lew Brady,
and on the pavement was a girl in evening finery.</p>
<p class="pindent">“A jolly evening, eh, Lola! When I get going, I’m a
mover, eh?”</p>
<p class="pindent">Ray Bennett’s voice was thick and unsteady. He had been
drinking—was within measurable distance of being drunk.</p>
<p class="pindent">With a yell he recognized the detective as he came into the
street.</p>
<p class="pindent">“Why, it’s old Elk—the Elk of Elks! Greetings, most noble
copper! Lola, meet Elky of Elksburg, the Sherlock of Fact,
the Sleuth——”</p>
<p class="pindent">“Shut up!” hissed the savage-voiced Lew Brady in his
ear, but Ray was in too exalted a mood to be silenced.</p>
<p class="pindent">“Where’s the priceless Gordon?—say, Elk, watch Gordon!
Look after poor old Gordon—my sister’s very much attached
to Gordon.”</p>
<p class="pindent">“Fine car, Mr. Bennett,” said Elk, regarding the machine
thoughtfully. “Present from your father?”</p>
<p class="pindent">The mention of his father’s name seemed to sober the young
man.</p>
<p class="pindent">“No, it isn’t,” he snapped, “it belongs to a friend. ’Night,
Lola.” He pumped at the starter, missed picking up, and
stamped again. “S’long, Elk!”</p>
<p class="pindent">With a jerk the car started, and Elk watched it out of sight.</p>
<p class="pindent">“That young fellow is certainly in danger of knocking his
nut against the moon,” he said. “Had a good time, Lola?”</p>
<p class="pindent">“Yes—why?”</p>
<p class="pindent">She fixed her suspicious eyes upon him expectantly.</p>
<p class="pindent">“Didn’t forget to turn off the gas when you went out, did
you? If I was Shylock Holmes, maybe I’d tell from the stain
on your glove that you didn’t.”</p>
<p class="pindent">“What do you mean about gas? I never use the cooker.”</p>
<p class="pindent">“Somebody does, and he nearly cooked me and a friend of
mine—nearly cooked us good!”</p>
<p class="pindent">He saw her frown. Since she was a woman he expected her
to be an actress, but somehow he was ready to believe in her
sincerity.</p>
<p class="pindent">“There’s been a gas attack on Caverley House,” he explained,
“and not cooking gas either. I guess you’ll smell it
as you go up.”</p>
<p class="pindent">“What kind of gas—poison?”</p>
<p class="pindent">Elk nodded.</p>
<p class="pindent">“But who put it there—emptied it, or whatever is done
with gas?”</p>
<p class="pindent">Elk looked at her with that wounded expression which so
justly irritated his victims.</p>
<p class="pindent">“If I knew, Lola, would I be standing here discussing the
matter? Maybe my old friend Shylock Holmes would, but
I wouldn’t. I don’t know. It was upset in Mr. Broad’s
flat.”</p>
<p class="pindent">“That is the American who lives opposite to us—to me,”
she said. “I’ve only seen him once. He seems a nice man.”</p>
<p class="pindent">“Somebody didn’t think so,” said Elk. “I say, Lola,
what’s that boy doing—young Bennett?”</p>
<p class="pindent">“Why do you ask me? He is making a lot of money just
now, and I suppose he is running a little wild. They all do.”</p>
<p class="pindent">“I didn’t,” said Elk; “but if I’d made money and started
something, I’d have chosen a better pacemaker than a dud
fighting man.”</p>
<p class="pindent">The angry colour rose to her pretty face, and the glance
she shot at him was as venomous as the gas he had fought all
night.</p>
<p class="pindent">“And I think I’d have put through a few enquiries to central
office about my female acquaintances,” Elk went on remorselessly.
“I can understand why you’re glued to the game,
because money naturally attracts you. But what gets me
is where the money comes from.”</p>
<p class="pindent">“That won’t be the only thing that will get you,” she said
between her teeth as she flounced into the half-opened door of
Caverley House.</p>
<p class="pindent">Elk stood where she had left him, his melancholy face
expressionless. For five minutes he stood so, and then walked
slowly in the direction of his modest bachelor home.</p>
<p class="pindent">He lived over a lock-up shop, a cigar store, and he was the
sole occupant of the building. As he crossed Gray’s Inn Road,
he glanced idly up at the windows of his rooms and noted that
they were closed. He noticed something more. Every pane
of glass was misty with some yellow, opalescent substance.</p>
<p class="pindent">Elk looked up and down the silent street, and at a short
distance away saw where road repairers had been at work.
The night watchman dozed before his fire, and did not hear
Elk’s approach or remark his unusual action. The detective
found in a heap of gravel, three rounded pebbles, and these
he took back with him. Standing in the centre of the road,
he threw one of the pebbles unerringly.</p>
<p class="pindent">There was a crash of glass as the window splintered.
Elk waited, and presently he saw a yellow wraith of poison-vapour
curl out and downward through the broken pane.</p>
<p class="pindent">“This is getting monotonous,” said Elk wearily, and walked
to the nearest fire alarm.</p>
<div class="calibre2"><span id="Page_49" title="49"></span><div class="pg-boilerplate" id="calibre_pb_0"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?0aaafaf1